// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"SZ-z","subtitle":"TZ-z","wrapper":"UZ-z","leftArrow":"VZ-z","rightArrow":"WZ-z"};